import Footer from "../components/Footer";

export default function Blog() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">Blog</h1>
        <p className="mt-2 text-text">Ressources, guides et nouveautés produit.</p>
        <div className="mt-4 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {[{
            title: "Bien démarrer avec DawaRedacc",
            desc: "Playbooks, pipeline et publication en 10 minutes.",
          },{
            title: "Structurer un article SEO efficace",
            desc: "H1 unique, hiérarchie H2/H3, lisibilité et E‑E‑A‑T.",
          },{
            title: "Mesurer et itérer",
            desc: "Utiliser le score et l’historique de révisions pour progresser.",
          }].map((p) => (
            <article key={p.title} className="rounded border p-4">
              <h2 className="font-semibold">{p.title}</h2>
              <p className="mt-1 text-sm text-muted">{p.desc}</p>
              <button className="mt-2 text-sm underline">Lire</button>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
